import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "maritime-law.webp",
    title: "海关法",
    crumb: "海关法",
  },
  icon: "fa-solid fa-warehouse",
  shortDescription:
    "为优化海关制度、合规性和物流操作，提供海关法和对外贸易的全面咨询。",

  title: "海关法",
  features: {
    title: "海关法",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle:
      "海关规划、法规合规及运营策略设计，适用于进出口和过境业务。",
    description: `海关诊断与规划服务：我们识别适用的法规框架，进行货物分类，提出制度建议，并设计运营流程，以最小化海关风险和成本，确保符合法定主管部门要求。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "diagnostico",
        title: "海关环境诊断与分析",
        summary:
          "对运营环境进行全面评估：物流路线、进出口点及相关参与方（货运代理、港口运营商）。",
        details:
          "我们绘制物流链并进行当前合规性诊断，识别瓶颈、违规风险及进出口和海关过境流程中的优化机会。",
        deliverables: [
          "海关诊断报告",
          "物流流程与风险点地图",
          "优先改进建议"
        ],
        requiredDocs: [
          "当前进出口流程",
          "与代理/物流的合同",
          "近期海关文件（报关单、舱单）"
        ],
        icon: "fa-solid fa-search",
        image: global.services + "customs_law/1.webp",
      },
      {
        key: "normativa",
        title: "适用法规识别与关税分类",
        summary:
          "确定法律框架、适用关税及货物的正确关税分类（HS）。",
        details:
          "分析现行法律、法令、决议和关税表；根据国际及本地规则进行关税分类（HS/SA）和海关估价，降低调整和处罚风险。",
        deliverables: [
          "按产品关税分类表",
          "适用法规义务报告",
          "税费及相关成本估算"
        ],
        requiredDocs: [
          "货物技术/商业资料",
          "形式/最终发票",
          "原产地文件（如适用，证书）"
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "customs_law/2.webp",
      },
      {
        key: "regimenes",
        title: "海关制度规划与优惠利用",
        summary:
          "设计与评估海关制度（保税仓库、自由区、过境、临时准入、加工制度）。",
        details:
          "根据业务（临时进口、再出口、加工、保税仓库或自由区储存）评估海关制度的适用性，优化关税和仓储成本，并管理获取如退税或免税等优惠的要求。",
        deliverables: [
          "推荐制度评估",
          "海关制度实施计划",
          "节省模型与操作流程"
        ],
        requiredDocs: [
          "进出口历史",
          "仓储/运输合同",
          "先前许可或认证"
        ],
        icon: "fa-solid fa-box-open",
        image: global.services + "customs_law/3.webp",
      },
      {
        key: "optimización",
        title: "合规优化与运营流程改进",
        summary:
          "优化内部流程、文件和清关流程，以减少时间和突发状况。",
        details:
          "我们设计标准化的海关清关流程、文件预审、会计-海关对账、库存控制及审计文件准备，结合自动化和检查清单以减少错误。",
        deliverables: [
          "海关流程手册",
          "清关与收货检查清单",
          "文件与控制模板"
        ],
        requiredDocs: [
          "当前流程",
          "管理/ERP系统（如适用）",
          "先前差异报告"
        ],
        icon: "fa-solid fa-cogs",
        image: global.services + "customs_law/4.webp",
      },
      {
        key: "operativa",
        title: "运营策略与海关供应链设计",
        summary:
          "重新设计物流链以提升时效、成本及与海关和港口运营商的协作。",
        details:
          "我们提出替代路线、与运营商达成协议、优化集拼/拆拼及文件同步以提前清关。包括适当Incoterms选择建议及与海关代理和船公司合同管理。",
        deliverables: [
          "海关供应链运营计划",
          "与运营商及SLA协议模型",
          "Incoterms及合同条款建议"
        ],
        requiredDocs: [
          "与代理和承运人合同",
          "时效与延误记录",
          "库存与集拼政策"
        ],
        icon: "fa-solid fa-route",
        image: global.services + "customs_law/5.webp",
      },
      {
        key: "riesgos",
        title: "风险管理、海关审计与培训",
        summary:
          "控制方案、内部审计及培训，降低处罚风险并提升持续合规性。",
        details:
          "我们实施海关风险管理计划，帮助企业应对检查和审计，并为运营及管理团队提供分类、估价、文件和预防性控制的专项培训。",
        deliverables: [
          "海关风险管理方案",
          "内部审计报告与行动计划",
          "定制培训计划（研讨会及资料）"
        ],
        requiredDocs: [
          "先前审计报告",
          "违规与罚款记录",
          "关键人员及岗位名单"
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "customs_law/6.webp",
      }
    ],
  },
  ctaText: "申请海关咨询",
  ctaLink: "/contact?service=customs-law",
};
